import { BlueDeniedSpotIllustration } from '@y2/mango/components/illustrations/spot';
import styles from './contact-form-error-message.module.scss';
import texts from './contact-form-error-message.texts.json';
import Link from 'next/link';
import { BackButton } from '../back-button/back-button';

export const ContactFormErrorMessage = () => {
  return (
    <div className={styles.contentBox}>
      <BlueDeniedSpotIllustration className={styles.illustration} />
      <div className={styles.textBox}>
        <h2 className={styles.title}>{texts.submissionFailed}</h2>
        <p>{texts.description}</p>
      </div>
      <Link href="/">
        <BackButton>{texts.backToHomePage}</BackButton>
      </Link>
    </div>
  );
};
